import React, {useEffect, useState} from 'react'

import DatePicker from "react-modern-calendar-datepicker";

const FilterByDate = ({setFilterDate, mobileMode=false, removeFilterDate}) => {
    const [selectedStartDate, setSelectedStartDate] = useState(null)
    const [selectedEndDate, setSelectedEndDate] = useState(null)
    useEffect(() => {
        console.log("date", selectedStartDate)
    }, [selectedStartDate])
    return (
      !mobileMode ? (
        <div className="filter-transaction-container  bg-white shadow-sm rounded">
          <div className="form-holder">
            <div className="form-group row">
                <div className="col-12 form-inline-filter">
                  <div className="col-md-6 col-sm-12 date-picker-filter">
                    <label className="col-sm-2 col-form-label">
                      تاریخ شروع
                    </label>
                    <div className="col-sm-10">
                      <DatePicker
                        value={selectedStartDate}
                        onChange={(data) => {
                            setSelectedStartDate(data);
                        }}
                        inputPlaceholder="تاریخ شروع"
                        shouldHighlightWeekends
                        locale="fa"
                        style={{ width: "100%" }}
                        id="sampling-date1"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12  date-picker-filter">
                    <label className="col-sm-2 col-form-label">
                      تاریخ پایان
                    </label>
                    <div className="col-sm-10">
                      <DatePicker
                        value={selectedEndDate}
                        onChange={(data) => {
                            setSelectedEndDate(data);
                        }}
                        inputPlaceholder="تاریخ پایان"
                        shouldHighlightWeekends
                        locale="fa"
                        style={{ width: "100%" }}
                        id="sampling-date2"
                      />
                    </div>
                  </div>
                </div>
              </div>
          </div>
          <button
            className="btn btn-sm btn-success btn-export"
            onClick={() => {
              setFilterDate(selectedStartDate, selectedEndDate)
            }}
          >
            اعمال فیلتر
          </button>
          <button
            className="btn btn-sm btn-danger btn-export"
            onClick={() => {
              setSelectedStartDate(null)
              setSelectedEndDate(null)
              removeFilterDate()
            }}
          >
           حذف فیلتر
          </button>
        </div>
    ) : (
        <div className="filter-transaction-container mobile-filter bg-white shadow-sm rounded">
          <div className="form-holder">
            <div className="form-group row">
              <div className="col-12 date-picker-filter">
                <label className="col-4 col-form-label">
                  تاریخ شروع
                </label>
                <div className="col-8">
                  <DatePicker
                    value={selectedStartDate}
                    onChange={(data) => {
                        setSelectedStartDate(data);
                    }}
                    inputPlaceholder="تاریخ شروع"
                    shouldHighlightWeekends
                    locale="fa"
                    style={{ width: "100%" }}
                    id="sampling-date1"
                  />
                </div>
              </div>
              <div className="col-12  date-picker-filter">
                <label className="col-4 col-form-label">
                  تاریخ پایان
                </label>
                <div className="col-8">
                  <DatePicker
                    value={selectedEndDate}
                    onChange={(data) => {
                        setSelectedEndDate(data);
                    }}
                    inputPlaceholder="تاریخ پایان"
                    shouldHighlightWeekends
                    locale="fa"
                    style={{ width: "100%" }}
                    id="sampling-date2"
                  />
                </div>
              </div>
            </div>
          </div>
          <button
            className="btn btn-sm btn-success btn-export"
            onClick={() => {
              setFilterDate(selectedStartDate, selectedEndDate)
            }}
          >
           اعمال فیلتر
          </button>
          <button
            className="btn btn-sm btn-danger btn-export"
            onClick={() => {
              setSelectedStartDate(null)
              setSelectedEndDate(null)
              removeFilterDate()
            }}
          >
           حذف فیلتر
          </button>
        </div>
    )
    )
}

export default FilterByDate